<template>
<div class="card">
   <h6>YOUR CURRENT ENERGY SUPPLY</h6>
   <h4>Approximately what percentage of your Electricity used is at night?</h4>

   <div class="row">
      <div class="col-md-12">
         <h3 class="_margin-top-20">{{ quote.economy7Percentage }}%</h3>
         <vue-slider
            v-model="quote.economy7Percentage"
            :useKeyboard="true"
            tooltip="focus"
            :dot-size="26"
            :min="1"
            :contained="true" />
      </div>
   </div>

   <div class="row _margin-bottom-20">
       <div class="col-xs-12">
           <small>A home typically heated mainly by electricity fall within 42% national average. You are able to adjust this figure using the toggle.</small>
       </div>
   </div>
</div>
</template>

<script>
import VueSlider from 'vue-slider-component';

import { mapState } from 'vuex';

export default {
  name: 'Economy7Percentage',
  data () {
    return {
      requesting: false
    };
  },
  props: {
    $v: Object
  },
  computed: {
    ...mapState({
      quote: ({ quote }) => quote
    })
  },
  components: {
    VueSlider
  }
};
</script>

<style lang="scss">
</style>
